export enum UserRole {
	Admin = 'admin',
	Regular = 'regular',
	MerchantEmerald = 'merchantEmerald',
	MerchantSapphire = 'merchantSapphire',
	MerchantRuby = 'merchantRuby',
	MerchantDiamond = 'merchantDiamond',
	Consumer = 'consumer',
}
